import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef, model, effect } from '@angular/core';
import { ToasterService } from '@abp/ng.theme.shared';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { ErrorFormControlDirective } from '@digiwall/core';
import { LocalizationModule } from '@abp/ng.core';
import { DuplicationRequestDto } from '@digiwall/goliath-documents/proxy';
import { Observable } from 'rxjs';
import { DocumentCloneHelperService } from 'projects/goliath-documents/src/lib/services/documents/document-clone-helper.service';

@Component({
  selector: 'document-quote-dialog-box-clone',
  templateUrl: 'quote-dialog-box-clone.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    ErrorFormControlDirective,
    LocalizationModule,
  ],
})
export class QuoteDialogBoxCloneComponent implements OnInit {
  documentId = model<string>();
  docService = model<{
    cloneWithAnnexesAndReevaluateTariff: (
      duplicationRequest: DuplicationRequestDto,
    ) => Observable<{ id: string }>;
    createNewVersion: (duplicationRequest: DuplicationRequestDto) => Observable<{ id: string }>;
  }>();
  fromList = model<boolean>();

  public canCreateVersion = model<boolean>(true);

  areAnnexesIncluded = model<boolean>(true);

  form: FormGroup;

  constructor(
    protected toastService: ToasterService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected formBuilder: FormBuilder,
    protected modal: NgbActiveModal,
    protected changeDetector: ChangeDetectorRef,
    private cloneHelper: DocumentCloneHelperService,
  ) {
    effect(() => {
      if (!this.areAnnexesIncluded()) {
        this.form?.get('copyAnnexes').disable();
      }
    });
  }

  ngOnInit(): void {
    this.initForm();
    this.initFormObservers();
  }

  protected clone() {
    const request = this.form.get('createVersion').value
      ? this.docService().createNewVersion
      : this.docService().cloneWithAnnexesAndReevaluateTariff;

    this.cloneHelper
      .clone(request, {
        docId: this.documentId(),
        withAnnexes: this.form.get('copyAnnexes').value,
        reevaluateTariff: this.form.get('reevaluateTariff').value,
        replaceInvalidArticles: false,
      })
      .subscribeOnce(response => {
        this.modal.close();
        this.toastService.success('Doc::Duplicated');
        this.router.navigate([this.fromList() ? './' : '../', response.id], {
          relativeTo: this.route,
        });
      });
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      createVersion: [false, Validators.required],
      reevaluateTariff: [false],
      copyAnnexes: [false],
    });
  }

  private initFormObservers(): void {
    this.form.get('createVersion').valueChanges.subscribe((createVersion: boolean) => {
      if (createVersion) {
        this.form.get('copyAnnexes').disable();
        this.form.get('copyAnnexes').setValue(true);
      } else {
        this.form.get('copyAnnexes').enable();
        this.form.get('copyAnnexes').setValue(false);
      }
    });
  }
}
